import React, { useMemo } from 'react';

function FilterPanel({ ideas, selectedMasters, selectedCategories, onToggleMaster, onToggleCategory }) {
  const { masters, byMaster } = useMemo(() => {
    const mastersCount = new Map();
    const map = new Map(); // master -> Map(sub -> count)
    (ideas || []).forEach((i) => {
      const m = i?.master_category || null;
      const c = i?.category?.name || null;
      if (m) mastersCount.set(m, (mastersCount.get(m) || 0) + 1);
      if (m && c) {
        if (!map.has(m)) map.set(m, new Map());
        const sub = map.get(m);
        sub.set(c, (sub.get(c) || 0) + 1);
      }
    });
    const masters = Array.from(mastersCount.entries()).sort((a, b) => b[1] - a[1]).map(([name, count]) => ({ name, count }));
    const byMaster = Array.from(map.entries()).reduce((acc, [m, subMap]) => {
      acc[m] = Array.from(subMap.entries()).sort((a, b) => b[1] - a[1]).map(([name, count]) => ({ name, count }));
      return acc;
    }, {});
    return { masters, byMaster };
  }, [ideas]);

  return (
    <aside className="panel filters" style={{ alignSelf: 'start', height: 'auto' }}>
      <h2 style={{ marginTop: 0 }}>Filters</h2>
      <div className="stack">
        <div>
          <h4 style={{ margin: 0 }}>Categories</h4>
          <div className="control-list" style={{ marginTop: 8 }}>
            {masters.length === 0 && <p className="text-muted">No master categories</p>}
            {masters.map((m) => {
              const id = `m-${m.name}`;
              const checked = !!selectedMasters?.includes(m.name);
              return (
                <label key={m.name} className="control">
                  <input type="checkbox" id={id} checked={checked} onChange={() => onToggleMaster(m.name)} />
                  <span>{m.name} <small className="text-muted">({m.count})</small></span>
                </label>
              );
            })}
          </div>
        </div>

        {selectedMasters && selectedMasters.length > 0 && (
          <div>
            <div className="stack" style={{ marginTop: 16 }}>
              {selectedMasters.map((m) => (
                <div key={m}>
                  <h5 style={{ margin: 0 }}>{m}</h5>
                  <div className="control-list" style={{ marginTop: 8 }}>
                  {(byMaster[m] || []).map((c) => {
                    const id = `cat-${m}-${c.name}`;
                    const checked = !!selectedCategories?.includes(c.name);
                    return (
                      <label key={id} className="control">
                        <input type="checkbox" id={id} checked={checked} onChange={() => onToggleCategory(c.name)} />
                        <span>{c.name} <small className="text-muted">({c.count})</small></span>
                      </label>
                    );
                  })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}

export default FilterPanel;


